//attach-property
//doc-upload
import React from 'react'
import Layout from '../../components/Layout'
import ScrollToTop from '../../components/ScrollToTop'
import SessionCheck from '../../components/SessionCheck'
import NavHeader from '../../components/NavHeader'
import MortgageBvnVerification from '../../views/MortgageView/bvn-verification/mortgage-bvn-verification'

const MortgageBVNVerificationPage = () => {
  return (
    <Layout>
    <ScrollToTop />
    <SessionCheck shouldRedirect />
    <NavHeader pageTitle="Mortgage-Application" routeName="BVN-Verification-Mortgage" />
    <MortgageBvnVerification />
  </Layout>
  ) 
}

export default MortgageBVNVerificationPage